export default {
  state: {
    id: undefined,
    mailer_method: undefined,
    queued_at: undefined,
    send_at: undefined,
    sent_at: undefined,
    error_count: undefined,
    last_error: undefined,
    last_error_code: undefined,
    last_errored_at: undefined,
    loading: false,
    created_at: undefined,
    updated_at: undefined,
    last_bounced_at: undefined,
    last_clicked_at: undefined,
    last_delivered_at: undefined,
    last_complained_at: undefined,
    last_opened_at: undefined,
    last_sns: undefined,
    recipient_email: undefined,
    newsletter_id: undefined,
    newsletter_type_subscriber_id: undefined,
    permanent_bounce: false,
    status: undefined,
    user_id: undefined,
    uuid: undefined
  }
}



// WEBPACK FOOTER //
// ./src/stores/NewsletterRecipientStore.js